<template>
    <div>
        <md-dialog :md-active.sync="show" style="overflow-y: scroll; ">
            <div class="horizontal-wrapper" style="flex: 0 0 auto;">
                <md-dialog-title style="display: inline">Grenzwerte festlegen</md-dialog-title>
             
            </div>
            <div class="vertical-wrapper" style="margin: 0 24px">
                <md-field>
                    <label for="">Grenzwert</label>
                    <md-select v-model="activeMessageFrameId">
                        <md-option v-for="mf in messageFrames" :key="mf.key" :value="mf.key">{{ mf.name }}</md-option>

                        <md-option :key="'add-key'" :value="-1">+</md-option>

                    </md-select>
                </md-field>

                <list :items="navigatorItems" class="navbar" v-on:item-clicked="navigateTo"/>
                
                <div v-if="navigatorItems[0].active" class="vertical-wrapper">
                    <md-field>
                        <label for="">Name</label>
                        <md-input v-model="mf.name"></md-input>
                    </md-field>

                    <md-field>
                        <label for="">Titel</label>
                        <md-input v-model="mf.kategories"></md-input>
                    </md-field>
                </div>

                <div v-if="navigatorItems[1].active" class="vertical-wrapper">
                    <md-field>
                        <label for="">MAX</label>
                        <md-input type="numeric"  v-model="mf.max"></md-input>
                    </md-field>

                    <md-field>
                        <label for="">MIN</label>
                        <md-input type="numeric"  v-model="mf.min"></md-input>
                    </md-field>
                </div>

                <div v-if="navigatorItems[2].active" class="vertical-wrapper" style="overflow-y: scroll;">

                    <md-switch class="md-primary" v-for="g in mf.groups" v-model="g.active" :key="g.key">{{ g.name }}</md-switch>
                </div>
            </div>

            <md-dialog-actions style="flex: 0 0 auto; padding: 24px" class="horizontal-wrapper">

                <md-button class="md-primary" style="flex: 1 0 0" v-on:click="open=false">Schließen</md-button>
                <md-button class="md-primary md-raised" style="flex: 1 0 0" v-if="!navigatorItems[2].active" v-on:click="navigateToNext">Weiter</md-button>

                <md-button class="md-primary md-raised" style="flex: 1 0 0" v-if="navigatorItems[2].active" v-on:click="save">Speichern</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>
<script>
import list from '@/components/VueComponents/list.vue'

export default {
    name: 'message-frame-dialog',
    components: { 
        list
    },
    props: {
        IDh_chart: [String, Number],
    },
    methods: {
        save(){
           
            
        },
        navigateTo(to){
            console.log(to)

        },
        navigateToNext(){
            for (let i = 0; i < this.navigatorItems.length; i++) {
                const e = this.navigatorItems[i];
                if (e.active && this.navigatorItems.length > i + 1) {
                    this.navigatorItems[i + 1].active = true;
                    this.navigatorItems[i].active = false;
                    break
                }
            }

        },

        async getMessageFrameSettings(chartId) {
            try {
                // Construct the URL with the chartId
                const url = `${this.$hostname}/api/message-frames/${chartId}/settings`;

                // Make the GET request using fetch
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token // Replace with actual token
                    }
                });

                // Check if the response is successful
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                // Parse the JSON response
                const data = await response.json();

                //
                data.forEach(e => {
                    e.key = this.$uuid.v4()
                    e.groups.forEach(g => g.key = this.$uuid.v4())
                })
                this.messageFrames = data;
                // Return the data
                return data;
            } catch (error) {
                console.error('Error fetching message frame settings:', error);
                throw error; // Re-throw the error after logging it
            }
        },

        async postMessageFrameSettings(chartId){
            try {
                // Construct the URL with the chartId
                const url = `${this.$hostname}/api/message-frames/${chartId}/settings`;

                const requestBody = {
                    ...this.mf
                }

                // Make the GET request using fetch
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token // Replace with actual token
                    },
                    body: JSON.stringify(requestBody)
                });

                // Check if the response is successful
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                // Parse the JSON response
                const data = await response.json();

                //
                data.forEach(e => {
                    e.key = this.$uuid.v4()
                    e.groups.forEach(g => g.key = this.$uuid.v4())
                })
                this.messageFrames = data;
                // Return the data
                return data;
            } catch (error) {
                console.error('Error fetching message frame settings:', error);
                throw error; // Re-throw the error after logging it
            }
        }

    },
    beforeRouteEnter (to, from, next) { 
        next(vm => { 
            vm.show = true
            //vm.IDh_chart = parseFloat(to.params.IDh_chart);
            vm.getMessageFrameSettings(parseInt(vm.IDh_chart));

            next();
        }) 
    },
   
    computed:{
        token(){
            return this.$store.getters.token
        },

        mf(){
            const m = this.messageFrames.find(e => e.key == this.activeMessageFrameId)
            return m? m : 
            // new add
            {}
        },
      
            
        
    },
    data(){
        return{
            navigatorItems: [
                {id: 1, text: 'Allgemein', active:true},
                {id: 2, text: 'Grenzwerte', active:false},
                {id: 3, text: 'Teilen', active:false}        
            ],

            show: false,
            activeTab: 0,
            messageFrames: [],

            activeMessageFrameId : 0
        }
    }
}
</script>